var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnitoLogoHeavyStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55,0C24.6,0,0,24.6,0,55s24.6,55,55,55,55-24.6,55-55S85.4,0,55,0Zm35.7,61.2v4.4c0,1.6-.7,3-1.9,4-1.1,.9-2.5,1.3-3.9,1.1-2.3-.4-4.2-2.8-4.3-5.2v-13.2c0-2.2-.7-4.2-2.3-6.1-1.5-1.8-3.3-2.9-5.6-3.5-2.8-.6-5.3-.1-7.6,1.5-2.6,1.8-4,4.2-4.5,7.1-.2,1.6-.3,3.2-.3,4.9-.1,4.4-.9,7.7-2.5,10.7-2.5,4.6-6.3,7.8-11,9.6-2.3,.9-4.7,1.3-7,1.3-.7,0-1.3,0-2-.1-4.5-.5-8.4-2.2-11.7-5.2-3-2.8-5-6.1-6-9.7-.5-1.8-.6-3.6-.7-5.2-.1-2.2-.1-4.4-.1-6.5v-5.7c0-1.2,.4-3.5,3.1-4.9,1.6-.9,3.5-.7,5,.5,1.7,1.3,2.5,3.4,2.1,5.5,0,.1-.1,.3-.1,.4v3.3c0,2.5-.1,5.1,0,7.6,.1,3,1.4,5.4,3.9,7.4,1.4,1.1,2.9,1.8,4.6,2.1,3,.5,5.6-.2,7.9-1.9,2-1.5,3.3-3.6,3.9-6.3,.1-.6,.1-1.3,.1-2,0-.6,0-1.2,.1-1.8s.1-1.3,.1-1.9c.1-1.6,.1-3.3,.6-5.1,1-3.8,2.5-6.8,4.7-9.3,2.5-2.8,5.4-4.8,8.8-6,5.1-1.7,10.3-1.3,15.1,1.1,6,3.1,9.7,8.1,10.9,14.9,.3,1.6,.4,3.2,.4,5.1,.2,2.4,.2,4.7,.2,7.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitoLogoHeavyStroke);
export default __webpack_public_path__ + "static/media/unito_logo_heavy_stroke.2525a3d5d21a923eb5a28bcffb5a325c.svg";
export { ForwardRef as ReactComponent };